module.exports = __webpack_public_path__ + "img/accent-girl.cde3064b.svg";